export default __webpack_public_path__ + "static/media/hd-pink-III.f7a03a80.mp4";